import type { SxProps, Theme } from '@mui/material/styles';

export const modelPortfolioRootStyles = {
  height: '100vh',
  overflow: 'hidden',
} satisfies SxProps<Theme>;
